__turbopack_context__.v({
  "badge": "styles-module-scss-module__pnDv6q__badge",
  "fixedWidth": "styles-module-scss-module__pnDv6q__fixedWidth",
  "footer": "styles-module-scss-module__pnDv6q__footer",
  "header": "styles-module-scss-module__pnDv6q__header",
  "infoIcon": "styles-module-scss-module__pnDv6q__infoIcon",
  "isDarkMode": "styles-module-scss-module__pnDv6q__isDarkMode",
  "progressBar": "styles-module-scss-module__pnDv6q__progressBar",
  "progressContainer": "styles-module-scss-module__pnDv6q__progressContainer",
  "pulszPointsValue": "styles-module-scss-module__pnDv6q__pulszPointsValue",
  "root": "styles-module-scss-module__pnDv6q__root",
  "statusText": "styles-module-scss-module__pnDv6q__statusText",
});
